import { AvatarStatus } from './AvatechClient'

export type AvatarFormatType = keyof typeof AvatarFormat
export const AvatarFormat = Object.freeze({
  live2d: 'live2d',
  threejs: 'threejs',
  rive: 'rive',
})

export type AvatarLoadProps = {
  avatarId?: string
  fileUrl?: string
  objectUrl?: string
  format?: AvatarFormatType
  callback?: (status: AvatarStatus) => void
  signal?: AbortSignal
}
